import Vue from 'vue'
// Components
Vue.component('Top', require('@/components/Top.vue').default)
Vue.component(
  'BtnWhatsapp',
  require('@/components/social/BtnWhatsapp.vue').default
)
// Pages
const pages = [
  // layout
  ['layout', './layout/Index.vue'],
  // Páginas
  ['Home', './Home.vue'],
  ['Contato', './Contato.vue'],
  ['Local', './Localizacao.vue'],
  ['Sobre', './Sobre.vue'],
  ['Horario', './Horario.vue'],
  ['Services', './Services.vue']
]

pages.filter((r) => {
  Vue.component(`${r[0]}`, require(`${r[1]}`).default)
})
